import { api, fetcher, wrappedCollectionFetcher } from "services/api.service";
import {
  defaultLocationTypeMovementBlock,
  LocationTypeMovementBlock,
} from "types/locationManagement/locationTypeMovementBlock";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: { params: Record<string, string | undefined> }) => {
  let block = defaultLocationTypeMovementBlock;
  if (params.locationTypeMovementBlockId) {
    const res = await fetcher<LocationTypeMovementBlock>(
      `/location_management/location_type_movement_blocks/${params.locationTypeMovementBlockId}`,
    );
    block = res;
  }
  const locationTypesRes = await wrappedCollectionFetcher<LocationManagementLocationType>(
    "/location_management/location_types?page[size]=100",
  );
  const locationTypes = locationTypesRes.rows || [];
  return { block, locationTypes };
});

export async function action({ request, params }: { request: Request; params: Record<string, string | undefined> }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "PUT",
      url: `/location_management/location_type_movement_blocks/${params.locationTypeMovementBlockId}`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 200) {
    return redirect("/location-type-movement-blocks");
  }
  return res;
}
